import Loading from "Components/Loading/Loading";
import { IStoreState } from "Interfaces";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Route, RouteProps, useHistory, useLocation } from "react-router-dom";

export const ProtectedRoute = (props: RouteProps) => {
  const tokens = useSelector((state: IStoreState) => state.auth.tokens);
  const status = useSelector((state: IStoreState) => state.auth.status);
  const history = useHistory();
  const { search } = useLocation();

  // If the URL contains a refresh_token we're mid-SAML redirect. The Router's
  // useMount will exchange it; don't redirect to /login while that's pending.
  const hasSamlToken = useMemo(
    () => new URLSearchParams(search).has("refresh_token"),
    [search],
  );

  useEffect(() => {
    if (hasSamlToken) return;
    if (history) {
      if (!tokens) {
        history.push("/login", { from: window.location.pathname });
      }
    }
  }, [history, tokens, status, hasSamlToken]);

  if (hasSamlToken)
    return <Loading text="Processing SAML redirect..." fullHeight />;
  return tokens ? <Route {...props} /> : <Loading fullHeight />;
};
